import React from 'react';
import classNames from 'classnames';
import Paragraph from "@scentregroup/ui/components/paragraph";
import { IssueSeverity } from '../../types';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

// aria-live needs to be rendered on mount to function correctly. See the spec: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Live_Regions
const ConditionalIssueText = _ref => {
  let {
    issue,
    showIssue = true,
    wrapperClass
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    "aria-live": "polite",
    className: classNames({
      [style.errorWrapper]: showIssue && issue
    }, wrapperClass),
    "data-id": "conditional-issue-text_index_ConditionalIssueText_div",
    children: showIssue && issue && /*#__PURE__*/_jsx(Paragraph, {
      className: issue.severity === IssueSeverity.Error ? style.error : style.warning,
      "data-id": "conditional-issue-text_index_ConditionalIssueText_Paragraph",
      children: issue.message
    })
  });
};

export default ConditionalIssueText;